import { render, staticRenderFns } from "./FacturacionData.vue?vue&type=template&id=50deced1&"
import script from "./FacturacionData.vue?vue&type=script&lang=js&"
export * from "./FacturacionData.vue?vue&type=script&lang=js&"
import style0 from "./FacturacionData.vue?vue&type=style&index=0&id=50deced1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports